<template>
  <div class="intro">
    <div class="container">
      <div class="outer">
        <div class="inner">
          <div class="box">
            <div class="header">
              <h1 class="bi">
                {{ $t('intro.brand') }}
              </h1>
            </div>
            <div class="body">
              <h2 class="title">
                {{ $t('intro.clubName') }}
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="close">
        {{ $t('common.close') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'introLayout',
  data () {
    return {
    }
  },
  created: function () {
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Intro.vue